
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class ToggleInput extends Vue {
  @Prop()
  value: unknown;

  edit(newVal: unknown) {
    this.$emit("input", newVal);
  }
}
